export const getQuorumText = (quorum: string) => {
  const quorumValue = quorum?.toString().trim();
  return !quorumValue || quorumValue === '-' ? 'N/A' : quorumValue;
};
